import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m17.775 17.295.415 3.733M14.503 10l4.758-.347c.896-.043 1.661.637 1.749 1.537a1.67 1.67 0 0 1-1.159 1.78l-5.704 1.822c-.896.307-1.377 1.295-1.027 2.174.327.812 1.224 1.251 2.054.966l2.885-.857a1.7 1.7 0 0 0 1.137-1.954M6.344 12.09A3.99 3.99 0 0 1 3 8.139c0-2.196 1.77-3.996 3.978-3.996.809 0 1.574.241 2.207.68"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M6.344 12.09A3.99 3.99 0 0 1 3 8.139c0-2.196 1.77-3.996 3.978-3.996.809 0 1.574.241 2.207.68"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M10.17 9.895a3.87 3.87 0 0 1-1.487-3.052C8.66 4.713 10.388 3 12.508 3a3.824 3.824 0 0 1 3.825 3.843c0 1.185-.525 2.218-1.355 2.942M10.3 10.027l-.983.044a3.29 3.29 0 0 0-3.104 2.723s-1.137 3.579-.394 4.128c.744.549 6.448-.857 4.809-2.943C9.229 12.223 7 14.99 7.065 20.172"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M5.82 16.922c.21.155.815.154 1.538.026m0 0c1.84-.325 4.447-1.472 3.27-2.969-1.07-1.344-2.627-.04-3.27 2.969m0 0c-.197.923-.308 2.007-.293 3.224"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const HugIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
